<script lang="ts" setup>
import { closeModal as pluginCloseModal } from '~/utils/Modal'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

interface Props {
  id: string
  width?: number
  height?: number
}

withDefaults(defineProps<Props>(), {
  width: 325,
  height: 646,
})

const playerEl: Ref = ref(null)
onMounted(() => {
  videojs(playerEl.value, {})
})

const closeModal = () => {
  pluginCloseModal()
}

</script>

<template>
  <div
    class="youtube-popup youtube-popup_visible"
    @click.self="closeModal"
  >
    <div class="youtube-popup__content border-top">
      <button
        class="youtube-popup__close-btn btn-close"
        aria-label="Закрыть"
        @click="closeModal"
      />
      <video
        ref="playerEl"
        :id="id + '-shorts'"
        class="video-js"
        controls
        autoplay
        preload="auto"
        data-setup="{}"
        :width="width"
        :height="height"
      >
        <source
          :src="'/vod/' + id + '.mp4/index.m3u8'"
          type="application/x-mpegURL"
        >
      </video>
    </div>
  </div>
</template>

<style lang="scss">
.youtube-popup {
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  z-index: 100;

  &::before {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100vw;
    height: 100vh;
    background: $black;
    content: "";
    opacity: 0.6;
  }

  &_visible {
    display: flex;
  }

  &__frame {
    width: rem(315px);
    height: rem(560px);
    max-height: 80vh;

    @include media-breakpoint-up(lg) {
      width: rem(630px);
      height: rem(1120px);
    }
  }

  &__content {
    z-index: 9;
    display: flex;
    flex-direction: column;
  }

  &__close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 9;
    width: rem(32px);
    height: rem(32px);
  }
}
</style>
